"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.concat.js");

var getZolaImageFromUuid = function getZolaImageFromUuid(imageId) {
  // resolve image host based on environment
  var env = typeof window !== 'undefined' && window.zola && window.zola.env || typeof process !== 'undefined' && process.env && process.env.ZOLA_ENV;
  return "//".concat(env === 'production' ? '' : 'stage-', "images.zola.com/").concat(imageId);
};

var _default = getZolaImageFromUuid;
exports.default = _default;